const guidGenerator = () => {
    const S4 = () => {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}

const getDefaultHeaders = () => {
    return {
            'Schwab-Client-CorrelId': guidGenerator(),
            'Schwab-Client-AppId': "AD00007961",
            'Schwab-Client-Channel': "IO",
            'Schwab-Resource-Version': "1.0"
    }
}

export { guidGenerator, getDefaultHeaders };